<template>
  <Modal nome="criarCurso">
    <Campo tipo="text" placeholder="Ex: Curso de Marketing" completar="false" label="Nome do curso" v-model="state.nome" />
    <Campo tipo="text" placeholder="Ex: Curso com foco em marketing" completar="false" label="Descrição do curso" v-model="state.descricao" />
    <Campo tipo="text" placeholder="https://pagina.com" completar="false" label="Página de vendas do curso" v-model="state.urlPaginaVenda" />
    <Campo tipo="text" placeholder="https://pagina.com/comprar" completar="false" label="Link para curso bloqueado" v-model="state.urlBloqueio" />
    <Imagem label="Capa do módulo" tamanho="Recomendado 1280x720" v-model:url="state.imagemCapa" :imagemPreenchida="state.imagemCapa" />
    <Imagem label="Imagem do Certificado" tamanho="Recomendado 1280x720" v-model:url="state.imagemCertificado" :imagemPreenchida="state.imagemCertificado" />
    <BotaoPrincipal nome="Criar curso" :disabled="state.loading" @click="criarCurso" />
  </Modal>
</template>

<script setup>
import { inject, reactive } from 'vue'
import { useStoreAreas, useStoreCursos, useStoreModal } from '@stores'
import { helperTexto } from '@helpers'

import Modal from '@components/global/modal/Modal.vue'
import Imagem from '@/components/global/elementos/Imagem.vue'
import Campo from '@/components/global/elementos/Campo.vue'
import BotaoPrincipal from '@components/global/elementos/BotaoPrincipal.vue'

const emitter = inject('emitter')
const storeAreas = useStoreAreas()
const storeCursos = useStoreCursos()
const storeModal = useStoreModal()

const state = reactive({
  nome: '',
  descricao: '',
  hotlink: '',
  imagemCapa: '',
  imagemCertificado: '',
  urlPaginaVenda: '',
  urlBloqueio: '',
  loading: false
})

function nomeParaHotlink() {
  state.hotlink = helperTexto.converterEmHotlink(state.nome)
}

async function criarCurso() {
  if (!validarDados()) return
  state.loading = true
  nomeParaHotlink()

  const idArea = storeAreas.area?._id

  const payload = {
    nome: state.nome,
    descricao: state.descricao,
    hotlink: state.hotlink,
    imagemCapa: state.imagemCapa,
    imagemCertificado: state.imagemCertificado,
    urlBloqueio: state.urlBloqueio,
    urlPaginaVenda: state.urlPaginaVenda
  }

  const adicionadoOk = await storeCursos.adicionar(idArea, payload)
  if (adicionadoOk !== true) return

  emitter.emit('atualizarCursos')
  storeModal.fecharModal('criarCurso')
  limparCampos()
}

function validarDados() {
  let mensagem
  if (!state.nome || !state.descricao || !state.imagemCapa || !state.urlBloqueio) mensagem = 'Preencha todos os campos obrigatórios'
  else return true

  emitter.emit('mostrarAlerta', { tipo: 'negativo', mensagem: mensagem })
  return false
}

function limparCampos() {
  state.nome = ''
  state.descricao = ''
  state.imagemCapa = ''
  state.imagemCertificado = ''
  state.urlPaginaVenda = ''
  state.urlBloqueio = ''
  state.loading = false
}
</script>

<style scoped>
.campo {
  margin: 0 0 15px 0;
}
.imagem {
  margin: 0 0 15px 0;
}
</style>
